import { useEffect } from 'react'
import {getListJobPositions} from '../../../services/Env/jobPosition.service'


const useGetJobPositionsMaintainer = (mantainerList, setMantainer) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListJobPositions();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({id: element.id , name: element.name, jobPositionCode: element.jobPositionCode, jobPositionNemo: ""})
                });

                setMantainer(aux_array);
            }
            catch (error) {
                setMantainer([]);
            }
        }
        
        if (mantainerList === null) {
            getData()
        }
    }, [mantainerList, setMantainer]);
}

const useGetJobPosition = (contracts, setContracts) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListJobPositions();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({
                        key: element.id,
                        text: `${element.name}`,
                        title:  `${element.name}`})
                });

                setContracts(aux_array);
            }
            catch (error) {
                setContracts([]);
            }
        }
        
        if (contracts === null) {
            getData()
        }
    }, [contracts, setContracts]);
}

export {
    useGetJobPositionsMaintainer,
    useGetJobPosition
}